import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import React from "react";


const EmployeeMonthlyLeaveChart=({leaves}:{leaves:any})=>{


    const leaveTypeColors: Record<string, string> = {
        GENERAL_LEAVE: "var(--info-hover)",
        SICK_LEAVE: "var(--danger-hover)",
        CASUAL_LEAVE: "var(--success-hover)",
        MATERNITY_LEAVE: "var(--birthday-border)",
        PATERNITY_LEAVE: "var(--work-anniversary-border)",
    };
    const chartData = React.useMemo(() => {
        if (!leaves?.length) return [];

        return leaves[0].months.map((month: any, index: number) => {
            const row: Record<string, any> = {
                month: month.month.substring(0, 3),
            };

            leaves.forEach((leave: any) => {
                row[leave.type] = leave.months[index]?.applied ?? 0;
            });

            return row;
        });
    }, [leaves]);

    function formatLeaveType(type: string): string {
        return type
            .toLowerCase()
            .split("_")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }
    return (
            <ResponsiveContainer width="60%" height={250}>
                <BarChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />

                    <XAxis dataKey="month" />
                    <YAxis />

                    <Tooltip />
                    <Legend />
                    {leaves.map((leave: any) => (
                        <Bar
                            key={leave.type}
                            dataKey={leave.type}
                            stackId="leave"
                            name={formatLeaveType(leave.type)}
                            fill={leaveTypeColors[leave.type] ?? "var(--pn-accent)"}
                        />
                    ))}
                </BarChart>
            </ResponsiveContainer>
    );


}

export default EmployeeMonthlyLeaveChart;
